import React from 'react';
import withIcon from '../utilities/withIcon';

const IconKey = () => {
  return (
    <g>
      <path d="m3.5095 3.5115a1.9416 1.9416 0 0 0 2.7461 2.7456 1.9451 1.9451 0 0 0 0-2.7451 1.99 1.99 0 0 0 -2.7461-.0005zm1.7558 1.7553a.5533.5533 0 0 1 -.7656 0 .5414.5414 0 1 1 .7656 0z" />
      <path d="m15.6481 13.0544a.7523.7523 0 0 0 -.2139-.4346l-4.8166-4.8166a5.5361 5.5361 0 1 0 -2.8157 2.8168l4.816 4.816a.7474.7474 0 0 0 .4346.2134l2.0156.26a.701.701 0 0 0 .0957.0063.7505.7505 0 0 0 .7441-.8457zm-12.8916-4.6298a4.0066 4.0066 0 1 1 5.666 0 4.0127 4.0127 0 0 1 -5.666 0zm10.7412 5.77-4.3971-4.3972c.1268-.1058.2635-.1933.3825-.3123s.2067-.2559.3125-.3828l4.3975 4.3977.1025.7974z" />
    </g>
  );
};

export default withIcon(IconKey);
